module.exports = __webpack_public_path__ + "static/media/melissa3.d0586ab2.jpg";